import styled from 'styled-components';

/** Shared styled primitives for the basic portal — simple, big, phone-first. */

export const Section = styled.section`
   margin-top: 14px;
   background: var(--app-surface, #fff);
   border: 1px solid var(--app-border, #e3e8ef);
   border-radius: 12px;
   padding: 14px;
`;

export const SectionHead = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   gap: 8px;
`;

export const SectionTitle = styled.h2`
   font-size: 14.5px;
   font-weight: 800;
`;

export const Hint = styled.p`
   margin-top: 4px;
   font-size: 12px;
   color: var(--app-text-dim, #55606c);
   line-height: 1.5;
`;

export const FormRow = styled.div`
   display: grid;
   grid-template-columns: 1fr 1fr;
   gap: 10px;
   margin-top: 10px;
`;

export const FormField = styled.div`
   min-width: 0;
`;

export const FormLabel = styled.label`
   display: block;
   font-size: 11.5px;
   font-weight: 700;
   margin-bottom: 4px;
`;

export const FormInput = styled.input`
   width: 100%;
   padding: 10px 11px;
   border-radius: 9px;
   border: 1.5px solid var(--app-border, #e3e8ef);
   font-size: 14px;
   &:focus {
      outline: none;
      border-color: #4f7cff;
   }
`;

export const FieldError = styled.div`
   margin-top: 8px;
   font-size: 11.5px;
   color: #dc3545;
   font-weight: 600;
`;

export const FormActions = styled.div`
   margin-top: 12px;
   display: flex;
   gap: 8px;
   flex-wrap: wrap;
`;

export const SmallBtn = styled.button`
   border: none;
   background: #4f7cff;
   color: #fff;
   border-radius: 9px;
   padding: 9px 15px;
   font-size: 13px;
   font-weight: 700;
   cursor: pointer;
   &:disabled {
      opacity: 0.6;
   }
`;

export const GhostBtn = styled.button`
   border: 1px solid var(--app-border, #e3e8ef);
   background: transparent;
   border-radius: 9px;
   padding: 8px 13px;
   font-size: 12.5px;
   font-weight: 600;
   cursor: pointer;
   color: var(--app-text-dim, #55606c);
`;

export const DangerSmallBtn = styled.button`
   border: none;
   background: #dc3545;
   color: #fff;
   border-radius: 9px;
   padding: 9px 15px;
   font-size: 13px;
   font-weight: 700;
   cursor: pointer;
   &:disabled {
      opacity: 0.6;
   }
`;

export const ToggleBtn = styled.button<{ $on: boolean }>`
   width: 100%;
   border: 1.5px solid
      ${({ $on }) => ($on ? '#198754' : 'var(--app-border, #e3e8ef)')};
   background: ${({ $on }) => ($on ? '#19875414' : 'transparent')};
   color: ${({ $on }) => ($on ? '#198754' : 'var(--app-text-dim, #55606c)')};
   border-radius: 9px;
   padding: 10px;
   font-size: 14px;
   font-weight: 700;
   cursor: pointer;
`;

export const Pill = styled.span<{ $tone: 'ok' | 'warn' | 'bad' | 'muted' }>`
   display: inline-flex;
   align-items: center;
   gap: 5px;
   padding: 3px 10px;
   border-radius: 999px;
   font-size: 11px;
   font-weight: 700;
   background: ${({ $tone }) =>
      $tone === 'ok'
         ? '#19875418'
         : $tone === 'warn'
         ? '#f5a52418'
         : $tone === 'bad'
         ? '#dc354518'
         : 'var(--app-border, #e3e8ef)'};
   color: ${({ $tone }) =>
      $tone === 'ok'
         ? '#198754'
         : $tone === 'warn'
         ? '#b97c0a'
         : $tone === 'bad'
         ? '#dc3545'
         : 'var(--app-text-dim, #55606c)'};
`;
